import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSectionUsers(id: string | undefined) {
  return useQuery(queries.locations.getSectionUsersById(id || ''))
}
